export interface ReportParams {
    applicationOrCategorySelection: string;
    applicationSelection: string[];
    breachSelection: string[];
    businessOwnerSelection: string[] | null;
    categorySelection: string[];
    clientSelection: string[];
    disableBrowsers: boolean;
    disableInactive: boolean;
    disablePersonal: boolean;
    disableUnclassified: boolean;
    discoveryOverviewMatrixTags: string[];
    endTime: number;
    excludeDormant: boolean;
    excludePersonalAccounts: boolean;
    groupSelection: string[];
    includeInactive: boolean;
    includeUncataloged: boolean;
    includeUntagged: boolean;
    managementStageSelection: string[];
    period: PeriodType;
    platformSelection: string[];
    platformTenantId?: string;
    reportSelections: string[];
    startTime: number;
    statusSelection: string[];
    subCategorySelection: string[];
    tagExclusion?: string[];
    tagSelection: string[];
    type: string;
    userOrGroupSelection: string;
    userSelection: string[];
}

export interface SubSubReportsList {
    type: string;
    subSubReports: string[];
}

export interface ReportConfigCheckboxesSubOptionsOptions {
    key: string;
    tooltip?: string;
}

export interface ReportConfigCheckboxesSubOptions {
    default?: boolean;
    hidden?: boolean;
    key: string;
    options?: ReportConfigCheckboxesSubOptionsOptions[];
}

export interface ReportConfigCheckboxesRequirements {
    key: string;
    values: string[];
}

export interface ReportConfigCheckboxes {
    reportEndpoint: string;
    subOptions: ReportConfigCheckboxesSubOptions[];
    type: string;
}

export interface ReportAdvancedSelections {
    disableBrowsersSelection: boolean;
    disableInactiveSelection: boolean;
    disablePersonalSelection: boolean;
    disableUnclassifiedSelection: boolean;
    excludeDormantSelection: boolean;
    excludePersonalAccountsSelection: boolean;
}

export interface ReportAppSelections {
    multi: boolean;
    startWithUnselected?: boolean;
}

export interface ReportMultiAppSelections {
    allSelection: boolean;
    appSelection: boolean;
    categorySelection: boolean;
    lifecycleStageSelection: boolean;
    managementStageSelection: boolean;
    platformSelection: boolean;
    subCategorySelection: boolean;
    tagSelection: boolean;
}

export interface ReportUsersSelectionOptions {
    multi: boolean;
}

export interface ReportUserSelections {
    allSelection: boolean;
    groupsSelection: boolean;
    usersSelectionOptions: ReportUsersSelectionOptions | null;
}

export interface ReportSetupSelections {
    advancedReportSelectionOptions: ReportAdvancedSelections | null;
    appSelectionOptions: ReportAppSelections | null;
    businessOwnerSelection: boolean;
    canBeShownAtPartnerLevel: boolean | null;
    clientSelection: boolean;
    multiAppSelectionOptions: ReportMultiAppSelections | null;
    subReportSelection: boolean;
    tagSelection: boolean;
    timePeriodSelection: boolean;
    userSelectionOptions: ReportUserSelections | null;
    vendorIncidentSelection: boolean;
}

export interface ReportConfig {
    checkboxes: ReportConfigCheckboxes[];
    hidden: boolean;
    selections?: object;
    setup: ReportSetupSelections;
    type: string;
}

export interface ReportTimeRange {
    startTime: number | undefined;
    endTime: number | undefined;
}

export enum PeriodOptions {
    daily = 'daily',
    weekly = 'weekly',
    monthly = 'monthly',
    quarterly = 'quarterly',
    period = 'period'
}

export type PeriodType =
    | PeriodOptions.daily
    | PeriodOptions.weekly
    | PeriodOptions.monthly
    | PeriodOptions.quarterly
    | PeriodOptions.period;

export type PlatformType = 'Desktop' | 'Cloud' | 'Hybrid' | '0';

export type MultiAppSelectionOptionsType =
    | 'allSelection'
    | 'appSelection'
    | 'categorySelection'
    | 'lifecycleStageSelection'
    | 'managementStageSelection'
    | 'platformSelection'
    | 'subCategorySelection'
    | 'tagSelection';

export type ReportAdvancedSelectionsType =
    | 'disableBrowsersSelection'
    | 'disableInactiveSelection'
    | 'disablePersonalSelection'
    | 'disableUnclassifiedSelection'
    | 'excludeDormantSelection'
    | 'excludePersonalAccountsSelection';

export type ReportAdvancedSelectionsValues =
    | 'disableBrowsers'
    | 'disableInactive'
    | 'disablePersonal'
    | 'disableUnclassified'
    | 'excludeDormant'
    | 'excludePersonalAccounts';

export type ReportUserSelectionsType =
    | 'allSelection'
    | 'groupsSelection'
    | 'usersSelectionOptions';

export type ReportTimePeriodSelectionsType =
    | 'dailySelection'
    | 'monthlySelection'
    | 'periodSelection'
    | 'quarterlySelection'
    | 'weeklySelection';
